var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_8097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8507 1.75647H0.149266C0.0668285 1.75647 0 1.8233 0 1.90574C0 1.98817 0.0668285 2.055 0.149266 2.055H12.8507C12.9332 2.055 13 1.98817 13 1.90574C13 1.8233 12.9332 1.75647 12.8507 1.75647Z",
    fill: "var(--hig-color-black-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80806 3.11025C3.4733 3.11025 4.01259 2.57096 4.01259 1.90571C4.01259 1.24046 3.4733 0.701172 2.80806 0.701172C2.14281 0.701172 1.60352 1.24046 1.60352 1.90571C1.60352 2.57096 2.14281 3.11025 2.80806 3.11025Z",
    fill: "white",
    stroke: "var(--hig-color-black-1)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8507 6.2345H0.149266C0.0668285 6.2345 0 6.30133 0 6.38376C0 6.4662 0.0668285 6.53303 0.149266 6.53303H12.8507C12.9332 6.53303 13 6.4662 13 6.38376C13 6.30133 12.9332 6.2345 12.8507 6.2345Z",
    fill: "var(--hig-color-black-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7436 7.58828C10.4089 7.58828 10.9481 7.04899 10.9481 6.38374C10.9481 5.71849 10.4089 5.1792 9.7436 5.1792C9.07835 5.1792 8.53906 5.71849 8.53906 6.38374C8.53906 7.04899 9.07835 7.58828 9.7436 7.58828Z",
    fill: "white",
    stroke: "var(--hig-color-black-1)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8507 10.6083H0.149266C0.0668285 10.6083 0 10.6751 0 10.7575C0 10.84 0.0668285 10.9068 0.149266 10.9068H12.8507C12.9332 10.9068 13 10.84 13 10.7575C13 10.6751 12.9332 10.6083 12.8507 10.6083Z",
    fill: "var(--hig-color-black-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24165 11.9621C5.9069 11.9621 6.44619 11.4228 6.44619 10.7575C6.44619 10.0923 5.9069 9.55298 5.24165 9.55298C4.5764 9.55298 4.03711 10.0923 4.03711 10.7575C4.03711 11.4228 4.5764 11.9621 5.24165 11.9621Z",
    fill: "white",
    stroke: "var(--hig-color-black-1)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_8097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12.6633,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8aaa2886.svg";
export { ForwardRef as ReactComponent };